import React from "react";
import Page from "components/Page";
import { Props } from "./PlatformUsers";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const PlatformUsers = lazyWithRetry(() => import("./PlatformUsers"));

export default (props: Props) => (
  <Page>
    <PlatformUsers {...props} />
  </Page>
);
